import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';

import {AffiliateReferralsTab} from './AffiliateReferralsTab';
import {AffiliateTiersTab} from './AffiliateTiersTab';

const MerchantAffiliateProgram = () => {
  const tabs: TabItem[] = [
    {
      id: 'tiers',
      title: 'Tiers',
      content: <AffiliateTiersTab key="tiers" />,
    },
    {
      id: 'referrals',
      title: 'Referrals',
      content: <AffiliateReferralsTab key="referrals" />,
    },
  ];

  return (
    <main className="my-5 mx-4 md:mx-10">
      <Header title="Affiliate Program" />
      <Tabs tabs={tabs} queryKey="tab" />
    </main>
  );
};

export default MerchantAffiliateProgram;
